import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import { ColorTypes } from "@omegagrid/core";
import { TreeAdapter } from "@omegagrid/tree";
import { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { Query, Resource, ResourceQuery } from "@reporting/rp-types/ext";
import rp from "@reporting/rp-app-host";
import { title } from "process";

export class SqlDependencyGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(private idProject: number) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		const idProject = this.idProject;
		if (this._columns) return this._columns;

		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 1,
			content: [{
				action: 'delete',
				icon: 'trash',
				title: msg('Delete'),
				color: ColorTypes.Red
			}],
			filter: false
		}, {
			data: 'id_custom_resource',
			header: msg('Resource'),
			t: 's',
			e: true,
			w: 200,
			l: 0,
			adapter: new class extends TreeAdapter {
				async getTree() {
					return (await rp.ms('extensions').get<Resource[]>('resources', {
						fields: ['id_custom_resource', 'name'],
						where: {id_custom_page: idProject},
						order: [['name', 'asc']]
					})).map(r => ({k: r.id_custom_resource.toString(), v: r.name}));
				}
			}
		}, {
			data: 'id_thread',
			header: msg('Query'),
			t: 's',
			e: true,
			w: 200,
			adapter: new class extends TreeAdapter {
				async getTree() {
					return (await rp.ms('extensions').get<Query[]>('queries', {
						fields: ['id_thread', 'description'],
						where: {id_custom_page: idProject},
						order: [['description', 'asc']]
					})).map(r => ({k: r.id_thread.toString(), v: r.description}));
				}
			}
		}];

		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		return (await rp.ms('extensions').get<ResourceQuery[]>(
			'queryDependencies',
			this.createRequestParams(filters, {
				where: {id_custom_page: this.idProject},
				order: [['resource_name', 'asc'], ['thread_name', 'asc']],
				count: this.pageSize
			})
		)).map(data => ({data: Object.assign(data, {
			id_custom_resource: {v: data.id_custom_resource, dv: data.resource_name},
			id_thread: {v: data.id_thread, dv: data.thread_name},
		}), props: {idz: data.idz}}));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: this.pageSize,
			refreshAfterSave: false,
			// exportTypes : ['csv', 'xlsx'],
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({
			_state: row.state,
			_index: row.index,
			idz: row.props.idz
		}, row.data));
		await rp.ms('extensions').post(`queryDependencies`, data);
	}

}
